import { TextareaHTMLAttributes, useRef, useCallback, useMemo } from 'react'

/* Textarea с автоматическим увеличением высоты до max-h-[260px], потом скролл */
export default function AutoResizeTextarea({
  className,
  onInput,
  ...rest
}: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const ref = useRef<HTMLTextAreaElement>(null)

  const handleInput = useCallback((e: React.FormEvent<HTMLTextAreaElement>) => {
    const t = e.currentTarget
    t.style.height = 'auto'
    t.style.height = `${Math.min(t.scrollHeight, 260)}px`
    onInput?.(e)
  }, [onInput])

  const mergedClassName = useMemo(
    () => `input-field resize-none ${className ?? ''}`,
    [className],
  )

  return (
    <textarea
      ref={ref}
      rows={3}
      onInput={handleInput}
      className={mergedClassName}
      {...rest}
    />
  )
}
